import { displayDate, displayTime } from '@adsk/alloy-react-datetime';
import { report, REPORT_TYPES } from '@adsk/exo-skeleton-api';

import { EXO_SKELETON_SCOPE_NAME } from '../consts';

export const formatDate = (
  date: string | undefined | null,
  messageToReport: string,
) => {
  if (!date) {
    report({
      scope: EXO_SKELETON_SCOPE_NAME,
      type: REPORT_TYPES.error,
      value: 'Date is not defined',
      context: {
        date,
      },
    });
    return undefined;
  }

  try {
    const dateToFormat = new Date(date);
    const formattedDate = displayDate(dateToFormat, {
      locale: 'en-US',
      year: false,
      weekday: true,
    });
    const formattedTime = displayTime(dateToFormat);
    return `${formattedDate} ${formattedTime}`;
  } catch (error) {
    report({
      scope: EXO_SKELETON_SCOPE_NAME,
      type: REPORT_TYPES.error,
      value: messageToReport,
      context: {
        date,
        error,
      },
    });
    return undefined;
  }
};
